<div *ngIf="data; else loadingTmpl" class="score-categories">
    <dp-score-subcategory *ngFor="let category of data.subCategories"
                          [data]="category"
                          class="mr-4">
    </dp-score-subcategory>
</div>
<ng-template #loadingTmpl>
    <lib-spinner class="spinner"></lib-spinner>
</ng-template>
